module.exports = __webpack_public_path__ + "img/icon-approval-red.70ed40cb.svg";